import { PUBLIC_PROGRAMS_STORE_KEY, PUBLIC_PROFILE_STORE_KEY } from './actionTypes';

export const selectPublicFinance = (state) => {
  const {
    keyValueStore: {
      [PUBLIC_PROFILE_STORE_KEY]: financeProfile,
      [PUBLIC_PROGRAMS_STORE_KEY]: matchedFinancePrograms,
    },
  } = state;
  return { financeProfile, matchedFinancePrograms };
};
